<template>
  <div class="page-project-baisc relative-position">
    <!-- <div class="absolute" style="right: 0; top: 0">
      <a-space v-if="data.state >= 4">
        <a-button type="primary" size="small" icon="form" @click="handleEdit" v-if="!editing">修改</a-button>
        <template v-else>
          <a-button type="primary" size="small" icon="check" :loading="saving" @click="confirmSubmit">保存</a-button>
          <a-button type="default" size="small" icon="close" @click="editing = false">取消</a-button>
        </template>
      </a-space>
    </div> -->
    <div class="panel-info-section">
      <div class="panel-info-section-title">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">基本信息</span>
      </div>
      <table class="table table-plain">
        <tbody>
          <tr>
            <th>项目名称</th>
            <td>{{ data.name }}</td>
            <th>项目编号</th>
            <td>{{ data.code }}</td>
          </tr>
          <tr>
            <th>项目实施周期</th>
            <td>
              {{ data.startDate ? data.startDate.substring(0, 10) : '' }}
              <template v-if="data.endDate">~ {{ data.endDate.substring(0, 10) }}</template>
            </td>
            <th valign="top"></th>
            <td></td>
          </tr>
          <tr>
            <th>学校名称</th>
            <td colspan="3">{{ extInfo.schoolName }}</td>
          </tr>
          <tr>
            <th>合作单位名称</th>
            <td colspan="3">{{ extInfo.cooperatorName }}</td>
          </tr>
          <tr>
            <th width="180">合作单位联系人姓名</th>
            <td width="40%">{{ extInfo.cooperatorContact }}</td>
            <th width="160">合作单位联系人手机</th>
            <td>{{ extInfo.cooperatorPhone }}</td>
          </tr>
          <tr>
            <th>书籍接收地址</th>
            <td colspan="3">{{ extInfo.bookReceiverAddr }}</td>
          </tr>
          <tr>
            <th>书籍接收人姓名</th>
            <td colspan="3">{{ extInfo.bookReceiverName }}</td>
          </tr>
          <tr>
            <th>书籍接收人手机</th>
            <td colspan="3">{{ extInfo.bookReceiverPhone }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-left v-mt-xs">
        <!-- <span class="hover-line text-indigo text-underline" @click="showLxFormData = true">查看更多信息</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { viewPrj } from '@/api/project/school'

export default {
  name: 'ProjectBasic',
  data() {
    return {
      loading: false,
      projectId: +this.$route.query.id,
      data: {},
      extInfo: {},
      showAllContent: false,
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      }
    },
    load() {
      this.loading = true
      viewPrj(this.projectId).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let { applicant, pools, studyInfo } = result
          this.applicant = applicant || {}
          this.pools = pools || []
          this.data = result
          this.extInfo = studyInfo || {}
        }
        this.loading = false
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
